import React from 'react';

import {Icon, Approve, EnvelopeClock} from '@optimaxdev/icons';
import classNames from 'classnames';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {
    FILL_DR_DETAILS_OR_UPLOAD_FILE,
    YOU_WILL_RECEIVE_A_CONFIRMATION,
    WE_WILL_VERIFY_THE_PRESCRIPTION,
    WE_GOT_IT,
    DONT_FORGET_TO_SEND_US_YOUR_DR_DETAILS,
    DONT_FORGET_TO_SEND_US_A_COPY_OF_YOUR_PRESCRIPTION,
} from '../../store/reducers/orderItems/constants';
import {getSuccessScreen} from '../../store/selectors/orderItems/orderItems';
import {getOrderId} from '../../store/selectors/selectors';
import {SuccessScreenType} from '../../types/orderItemsTypes';

import {DontForgetToSendUsYourDetailsOrPrescription} from './components/dontForgetToSendUsYourDetailsOrPrescription/dontForgetToSendUsYourDetailsOrPrescription';
import {WeGotIt} from './components/weGotIt/weGotIt';
import {WeWillVerifyPrescription} from './components/weWillVerifyPrescription/weWillVerifyPrescription';
import {YouWillReceiveAConfirmation} from './components/youWillReceiveAConfirmation/youWillReceiveAConfirmation';

import s from './successMessage.scss';

export type PropsType = {
    orderId: string;
    successScreen: SuccessScreenType;
};

const AWESOME_THANK_YOU = (
    <div className={s.finalScreen}>
        <div className={s.icon}>
            <Icon className={s.approve} icon={Approve} />
        </div>
        <h3 className={s.title}>
            Awesome! <br />
            Thank you for choosing us.
        </h3>
    </div>
);

const PLEASE_NOTE = (
    <div className={s.note}>
        <div className={s.icon}>
            <Icon icon={EnvelopeClock} />
        </div>
        <h3 className={s.title}>
            Please note, <br />
            we still need your Dr. details.
        </h3>
    </div>
);

const successMessageDetails = {
    [DONT_FORGET_TO_SEND_US_A_COPY_OF_YOUR_PRESCRIPTION]: {
        bottomSection: <DontForgetToSendUsYourDetailsOrPrescription isCopyOfPrescription />,
        topSection: PLEASE_NOTE,
    },
    [DONT_FORGET_TO_SEND_US_YOUR_DR_DETAILS]: {
        bottomSection: <DontForgetToSendUsYourDetailsOrPrescription />,
        topSection: PLEASE_NOTE,
    },
    [FILL_DR_DETAILS_OR_UPLOAD_FILE]: {
        bottomSection: null,
        topSection: (
            <div className={s.fillDrDetails}>
                <div className={s.icon}>
                    <Icon icon={Approve} role="presentation" />
                </div>
                <h3 className={s.title}>Great! You&apos;re almost done</h3>
            </div>
        ),
    },
    [WE_GOT_IT]: {
        bottomSection: <WeGotIt />,
        topSection: AWESOME_THANK_YOU,
    },
    [WE_WILL_VERIFY_THE_PRESCRIPTION]: {
        bottomSection: <WeWillVerifyPrescription />,
        topSection: AWESOME_THANK_YOU,
    },
    [YOU_WILL_RECEIVE_A_CONFIRMATION]: {
        bottomSection: <YouWillReceiveAConfirmation />,
        topSection: AWESOME_THANK_YOU,
    },
};

/**
 * Success message with order id on success page after place order
 * @param {PropsType} props - props
 * @returns {React.ReactElement} - SuccessMessage
 */
export const SuccessMessage: React.FC<PropsType> = ({orderId, successScreen}) => {
    const isFillDetailsUploadFile = successScreen === FILL_DR_DETAILS_OR_UPLOAD_FILE;

    return (
        <>
            <div
                className={classNames({
                    [s.container]: !isFillDetailsUploadFile,
                    [s.containerUploadFile]: isFillDetailsUploadFile,
                })}
            >
                {!isFillDetailsUploadFile && successMessageDetails[successScreen].topSection}
                <p
                    className={classNames({
                        [s.description]: !isFillDetailsUploadFile,
                        [s.descriptionUploadFile]: isFillDetailsUploadFile,
                    })}
                >
                    Order number: #{orderId}
                </p>
            </div>
            {successMessageDetails[successScreen].bottomSection}
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    orderId: getOrderId(store),
    successScreen: getSuccessScreen(store),
});

export const SuccessMessageConnected = connect(mapStateToProps)(SuccessMessage);
